import { EventEmitter } from 'events'
import * as Sentry from '@sentry/browser'
import { invalidAuth } from 'reduxModules/auth/'
import { types as confirmationTypes } from 'reduxModules/confirmation'
import { navigate } from '../utils/navigation'
import { normalizeErrors } from './modules/utils/forms'
import { toastServerError } from '../global/notifications'

// Custom error class to replace redux-form's SubmissionError
export class FormSubmissionError extends Error {
  constructor(errors) {
    super('Form submission error')
    this.name = 'FormSubmissionError'
    this.errors = errors
  }
}

export const sentryMiddleware = () => (next) => (action) => {
  // Prevent from catching forms errors
  if (action.payload && action.payload.status === 400) return next(action)
  try {
    return next(action)
  } catch (err) {
    Sentry.captureException(err, {
      extra: { action: action.type }
    })
    throw err
  }
}

export const fetchFailureMiddleware = () => (next) => (action) => {
  if (action.payload && action.payload.status === 400) {
    const response = action.payload.value
    const errors = normalizeErrors(response)
    next({ ...action, payload: response })
    throw new FormSubmissionError(errors)
  }
  return next(action)
}

export const authFailureMiddleware = (store) => (next) => (action) => {
  if (
    (action.payload && action.payload.status === 403) ||
    (action.payload &&
      action.payload.status === 401 &&
      action.payload.value &&
      (action.payload.value.detail === 'Signature has expired.' ||
        action.payload.value.detail === 'Error decoding signature.' ||
        action.payload.value.detail ===
          'A session is already active in another device, please logout and try again.'))
  ) {
    store.dispatch(invalidAuth())
    navigate('/', { state: { next: location.pathname } })
    toastServerError(action.payload.value.detail)
  }
  return next(action)
}

export const multiEffectsMiddleware =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    if (Array.isArray(action))
      return Promise.all(action.filter(Boolean).map(dispatch))
    return next(action)
  }

let pending

// eslint-disable-next-line no-unused-vars
export const confirmationMiddleware = (store) => (next) => (action) => {
  switch (action.type) {
    case confirmationTypes.INIT_CONFIRMATION:
      next(action)
      pending = new EventEmitter()
      return pending

    case confirmationTypes.RESOLVE_CONFIRMATION:
      pending.emit(action.payload.resolution, action.payload.feedback)
      pending = null
      // falls through
    default:
      return next(action)
  }
}

export default {
  authFailureMiddleware,
  fetchFailureMiddleware,
  multiEffectsMiddleware,
  confirmationMiddleware
}
